import { ApprovalsFiltersName } from "@/pages/inbox/types";

export const APPROVALS_FILTERS_NAME: { [key: string]: string } = {
  [ApprovalsFiltersName.Draft]: "Draft",
  [ApprovalsFiltersName.InProgress]: "In Progress",
  [ApprovalsFiltersName.Completed]: "Completed",
  [ApprovalsFiltersName.Rejected]: "Rejected",
  [ApprovalsFiltersName.Cancelled]: "Cancelled",
  [ApprovalsFiltersName.Returned]: "Returned",
};

export enum ApprovalsMessage {
  Filter = "filter",
}

export const DEFAULT_INBOX_FILTERS = "";

export const DEFAULT_INBOX_PAGE_SIZE = 10;
export const DEFAULT_INBOX_SUGGESTION_SIZE = 3;
export const DEFAULT_INBOX_PAGE_NUMBER = 1;
